export default {
  padding: '0.5rem 0',
  borderRadius: '4px',
};
